import { useAuth0 } from '@auth0/auth0-react';
import {
  createFileRoute,
  Outlet,
  redirect,
  stripSearchParams,
  useLocation,
  useNavigate,
} from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { WelcomeToConnectForBusinessModal } from 'src/apps/fleet/app/components/WelcomeToConnectForBusinessModal';
import { Modal } from 'src/components';

import { AppPage } from 'src/components/AppPage';
import { coerceSearchToBoolean } from 'src/utils/coerceSearchToBoolean';
import { z } from 'zod';

const defaultValues = {
  welcome: false,
};

const routeSearchSchema = z.object({
  welcome: z.preprocess(coerceSearchToBoolean, z.boolean()).optional(),
});

export const Route = createFileRoute('/_auth/enterprise/_with-org/_layout')({
  validateSearch: zodValidator(routeSearchSchema),
  search: { middlewares: [stripSearchParams(defaultValues)] },
  component: () => {
    const auth = useAuth0();
    const location = useLocation();
    const navigate = useNavigate();

    if (!auth.user) {
      throw redirect({
        to: '/login',
        search: {
          redirect: location.href,
        },
      });
    }

    return (
      <AppPage.Container className="flex max-w-l2xl grow flex-col justify-center">
        <Outlet />
        <Modal.Root
          open={!!location.search.welcome}
          onOpenChange={(open) => {
            if (!open) {
              void navigate({
                replace: true,
                to: '.',
                search: (s) => ({ ...s, welcome: undefined }),
              });
            } else {
              void navigate({
                replace: true,
                to: '.',
                search: (s) => ({ ...s, welcome: true }),
              });
            }
          }}
        >
          <WelcomeToConnectForBusinessModal />
        </Modal.Root>
      </AppPage.Container>
    );
  },
});
